import { CREATE_REMINDER, GET_REMINDER, REMINDER_REQUEST, DELETE_REMINDER, UPDATE_REMINDER, REMINDER_REQUEST_FAILURE } from "../types";

const initialState = {
  reminders: [],
  loading: false,
  error: null,
};

const reminderReducer = (state = initialState, action) => {
  switch (action.type) {
    case REMINDER_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_REMINDER: {
      return {
        ...state,
        reminders: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_REMINDER:
      return {
        ...state,
        reminders: [action.payload, ...state.reminders],
        loading: false,
        error: null
      };
    case UPDATE_REMINDER:
      const remindersData = state.reminders.slice(0);
      const uIndex = remindersData.findIndex((data) => data.id === action.payload.id);
      remindersData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        reminders: [ ...remindersData ],
        loading: false,
        error: null
      };
    case DELETE_REMINDER:
      const reminders = state.reminders?.slice(0);
      const index = reminders.findIndex((data) => data.id === action.id);
      if (index > -1) {
          reminders.splice(index, 1);
      }
      return {
        ...state,
        reminders: [...reminders],
        loading: false,
        error: null
      }
    case REMINDER_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default reminderReducer